/* Velbryn luxury layer (Oct 2026): slide-out cart drawer with free-shipping bar, image zoom,
   reveal-on-scroll, page fade and cart count animation. Runs after the theme's own scripts. */
(function () {
  'use strict';
  var FREE_SHIPPING_CENTS = 7000; // free US shipping on orders of $70 or more (matches Settings > Shipping)
  var doc = document, root = doc.documentElement;
  root.classList.add('lux-js');

  function money(cents) {
    try { if (window.Shopify && Shopify.formatMoney) return Shopify.formatMoney(cents, '${{amount}}'); } catch (e) {}
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?|$)/i, '_' + w + 'x$1$2');
  }

  /* ---------------- Cart drawer ---------------- */
  var drawer, overlay, body, foot, bar, countEl, busy = false;

  function build() {
    overlay = doc.createElement('div');
    overlay.className = 'lux-overlay';
    drawer = doc.createElement('aside');
    drawer.className = 'lux-drawer';
    drawer.setAttribute('role', 'dialog');
    drawer.setAttribute('aria-modal', 'true');
    drawer.setAttribute('aria-label', 'Your cart');
    drawer.innerHTML =
      '<div class="lux-drawer__head"><div style="display:flex;align-items:baseline"><h2 class="lux-drawer__title">Your Cart</h2><span class="lux-drawer__count"></span></div>' +
      '<button type="button" class="lux-drawer__close" aria-label="Close cart"><svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M2 2l12 12M14 2L2 14"/></svg></button></div>' +
      '<div class="lux-ship-bar"><p class="lux-ship-bar__text"></p><div class="lux-ship-bar__track"><div class="lux-ship-bar__fill"></div></div></div>' +
      '<div class="lux-drawer__body"></div>' +
      '<div class="lux-drawer__foot"></div>';
    doc.body.appendChild(overlay);
    doc.body.appendChild(drawer);
    body = drawer.querySelector('.lux-drawer__body');
    foot = drawer.querySelector('.lux-drawer__foot');
    bar = drawer.querySelector('.lux-ship-bar');
    countEl = drawer.querySelector('.lux-drawer__count');
    overlay.addEventListener('click', close);
    drawer.querySelector('.lux-drawer__close').addEventListener('click', close);
    doc.addEventListener('keydown', function (e) { if (e.key === 'Escape' && root.classList.contains('lux-drawer-open')) close(); });
    drawer.addEventListener('click', onDrawerClick);
  }

  function open() {
    root.classList.add('lux-drawer-open');
    refresh();
    setTimeout(function () { var c = drawer.querySelector('.lux-drawer__close'); if (c) c.focus({ preventScroll: true }); }, 350);
  }
  function close() { root.classList.remove('lux-drawer-open'); }

  function render(cart) {
    var n = cart.item_count;
    countEl.textContent = n ? n + (n === 1 ? ' item' : ' items') : '';
    // free shipping bar
    var left = FREE_SHIPPING_CENTS - cart.total_price, pct = Math.min(100, Math.round(cart.total_price / FREE_SHIPPING_CENTS * 100));
    bar.classList.toggle('is-free', left <= 0);
    bar.querySelector('.lux-ship-bar__text').innerHTML = n === 0
      ? 'Free US shipping on orders over <b>$' + FREE_SHIPPING_CENTS / 100 + '</b>'
      : left > 0 ? 'You are <b>' + money(left) + '</b> away from free US shipping' : 'You have unlocked <b>free US shipping</b>';
    bar.querySelector('.lux-ship-bar__fill').style.width = (n ? pct : 0) + '%';

    if (!n) {
      body.innerHTML = '<div class="lux-empty"><p>Your cart is empty</p><a class="lux-btn" href="/collections/all">Continue shopping</a></div>';
      foot.style.display = 'none';
      return;
    }
    foot.style.display = '';
    body.innerHTML = cart.items.map(function (it) {
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? it.variant_title : '';
      return '<div class="lux-line" data-key="' + esc(it.key) + '">' +
        '<a href="' + esc(it.url) + '"><img class="lux-line__img" src="' + esc(img(it.image, 200)) + '" alt="' + esc(it.product_title) + '" loading="lazy"></a>' +
        '<div><a class="lux-line__title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' +
        (variant ? '<p class="lux-line__variant">' + esc(variant) + '</p>' : '<p class="lux-line__variant"></p>') +
        '<div class="lux-line__row"><div class="lux-qty"><button type="button" data-qty="' + (it.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
        '<span>' + it.quantity + '</span><button type="button" data-qty="' + (it.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<span class="lux-line__price">' + money(it.final_line_price) + '</span></div>' +
        '<button type="button" class="lux-line__remove" data-qty="0">Remove</button></div></div>';
    }).join('');
    foot.innerHTML =
      '<div class="lux-subtotal"><span>Subtotal</span><strong>' + money(cart.total_price) + '</strong></div>' +
      '<p class="lux-note">Taxes and shipping are calculated at checkout.</p>' +
      '<a class="lux-btn" href="/checkout">Checkout</a>' +
      '<a class="lux-btn lux-btn--ghost" href="/cart">View cart</a>';
  }

  function syncCount(cart) {
    var els = doc.querySelectorAll('.js-number-cart, .enj-cartcount, .cart-counter, .number-cart');
    els.forEach(function (el) {
      var before = el.textContent.trim();
      el.textContent = cart.item_count > 0 ? cart.item_count : '';
      el.classList.toggle('active', cart.item_count > 0);
      if (String(cart.item_count) !== before) { el.classList.remove('lux-bump'); void el.offsetWidth; el.classList.add('lux-bump'); }
    });
  }

  function refresh() {
    return fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { render(cart); syncCount(cart); return cart; })
      .catch(function () {});
  }

  function onDrawerClick(e) {
    var b = e.target.closest('[data-qty]');
    if (!b || busy) return;
    var line = b.closest('.lux-line');
    if (!line) return;
    busy = true; drawer.classList.add('is-busy');
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: line.getAttribute('data-key'), quantity: Math.max(0, parseInt(b.getAttribute('data-qty'), 10) || 0) })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { if (cart && cart.items) { render(cart); syncCount(cart); } else { return refresh(); } })
      .catch(function () { return refresh(); })
      .then(function () { busy = false; drawer.classList.remove('is-busy'); });
  }

  // The theme shows a centred "Added to cart" popup after an ajax add; open the drawer instead.
  function hookAddToCart() {
    var orig = window.showPopup;
    window.showPopup = function (sel) {
      if (sel === '.product-popup') { open(); return; }
      if (typeof orig === 'function') return orig.apply(this, arguments);
    };
    if (window.jQuery) {
      jQuery(doc).ajaxComplete(function (ev, xhr, opts) {
        if (opts && /\/cart\/(add|change|update|clear)/.test(opts.url || '')) refresh();
      });
    }
  }

  // Header cart icon opens the drawer (capture phase, so the theme's own mini cart stays closed).
  doc.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('.js-call-minicart, a[href="/cart"].cart, .menu_toolbar a[href="/cart"]');
    if (!t || t.closest('.lux-drawer')) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);

  /* ---------------- Product image zoom ---------------- */
  function setupZoom() {
    if (!window.matchMedia || !matchMedia('(hover: hover) and (pointer: fine)').matches) return;
    doc.querySelectorAll('img.engoj_img_main').forEach(function (im) {
      if (im.closest('.sticky_addcart') || im.closest('.lux-zoom')) return;
      var box = im.parentElement;
      if (!box || im.naturalWidth && im.naturalWidth < 500) return;
      box.classList.add('lux-zoom');
      box.addEventListener('mouseenter', function () { box.classList.add('is-zoomed'); });
      box.addEventListener('mouseleave', function () { box.classList.remove('is-zoomed'); im.style.transformOrigin = '50% 50%'; });
      box.addEventListener('mousemove', function (e) {
        var r = box.getBoundingClientRect();
        im.style.transformOrigin = ((e.clientX - r.left) / r.width * 100) + '% ' + ((e.clientY - r.top) / r.height * 100) + '%';
      });
    });
  }

  /* ---------------- Reveal on scroll ---------------- */
  function setupReveal() {
    if (!('IntersectionObserver' in window)) return;
    if (window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('lux-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    var sel = '.grid-uniform .product-item-v1, .title_heading, .block-title, .section-banner-v11 .item-banner, .featured-icon, .tab-pd-details';
    doc.querySelectorAll(sel).forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight * 0.92) return; // already on screen: leave it visible
      el.classList.add('lux-reveal');
      io.observe(el);
    });
  }

  /* ---------------- Product card second image ---------------- */
  function setupSwatchGuard() {
    doc.addEventListener('click', function (e) {
      var s = e.target.closest && e.target.closest('[data-engojvariant-img]');
      if (!s) return;
      var card = s.closest('.product-item-v1');
      if (card) card.classList.add('lux-swatched');
    });
  }

  /* ---------------- Page transitions ---------------- */
  function setupLeave() {
    doc.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('a[href]');
      if (!a || e.defaultPrevented || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      if (a.target && a.target !== '_self') return;
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(javascript|mailto|tel):/i.test(href)) return;
      var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.origin !== location.origin || /\/checkout|\/cart|\/account/.test(u.pathname) || (u.pathname === location.pathname && u.hash)) return;
      if (a.hasAttribute('data-toggle') || a.closest('.lux-drawer')) return;
      root.classList.add('lux-leaving');
      setTimeout(function () { root.classList.remove('lux-leaving'); }, 1500); // safety if navigation is cancelled
    });
    window.addEventListener('pageshow', function () { root.classList.remove('lux-leaving'); });
  }

  /* ---------------- Value strip rotation (mobile) ---------------- */
  function setupStrip() {
    var list = doc.querySelector('.lux-strip__list');
    if (list && list.children.length === 4) list.classList.add('is-rotating');
  }

  function init() {
    build();
    doc.querySelectorAll('.enj-cartcount, .js-number-cart').forEach(function (el) { if (el.textContent.trim() === '0') el.textContent = ''; });
    hookAddToCart();
    setupZoom();
    setupReveal();
    setupSwatchGuard();
    setupLeave();
    setupStrip();
    window.VelbrynCart = { open: open, close: close, refresh: refresh };
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', setupZoom);
})();
